var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video_container",attrs:{"id":'aliplayer' + this._uid}},[_c('div',{staticClass:"inpictrue",on:{"click":_vm.requestPictureInPicture}},[_vm._v(_vm._s(_vm.$t("i18n_261"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }